// TreatmentPlanCard.jsx

import React, { useEffect, useState } from "react";
import { FaThermometerHalf } from "react-icons/fa";
import axiosInstance from "../../../axios/axios";
import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { useParams } from "react-router-dom";
import moment from "moment";

const TreatmentPlanCard = ({ onExportData }) => {
  const [plans, setPlans] = useState([]);

  const { pid } = useParams();

  const fetchTreatmentPlans = async () => {
    try {
      const payload = {
        patientId: pid,
      };

      const encryptedPayload = Encrypt_Value(payload, "vozo");

      const response = await axiosInstance.post(
        "vozo/patient/gettreatmentplan",
        encryptedPayload,
      );

      const decryptedData = Decrypt_Value(response.data, "vozo");

      const formatted = (Array.isArray(decryptedData) ? decryptedData : []).map(
        (item) => {
          let totalGoals = item.goals_status?.totalGoals || 0;

          let cancelledGoals = item.goals_status?.cancelled || 0;

          let completedGoals = item.goals_status?.completed || 0;

          if (cancelledGoals > 0) {
            totalGoals = totalGoals - cancelledGoals;
          }

          return {
            id: item.id,
            title: item.plan_name || "-",
            doctor: item.pov_name || "-",
            // date: item.plan_end_date || "-",
            date: item.plan_end_date
              ? moment(item.plan_end_date).format("MMM DD, YYYY")
              : "-",
            completedGoals,
            totalGoals,
          };
        },
      );

      /* UI → latest 3 */

      const latestPlans = formatted.sort((a, b) => b.id - a.id).slice(0, 3);

      setPlans(latestPlans);

      /* PARENT → FULL ARRAY */

      if (onExportData) {
        onExportData(
          formatted.map((item) => ({
            treatmentPlan: item.title,
            provider: item.doctor,
            endDate: item.date,
            completedGoals: item.completedGoals,
            totalGoals: item.totalGoals,
          })),
        );
      }
    } catch (error) {
      console.log("Treatment Plan Error", error);

      setPlans([]);
    }
  };

  useEffect(() => {
    fetchTreatmentPlans();
  }, []);

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FaThermometerHalf className="care-summary-main-icon treatment-icon" />

        <h3 className="care-summary-title">Treatment Plan</h3>
      </div>

      <div className="care-summary-body">
        {plans.map((item, index) => (
          <div
            key={index}
            className={`care-summary-row ${
              index !== plans.length - 1 ? "care-summary-border" : ""
            }`}
          >
            <div className="care-summary-content">
              <div className="care-summary-heading">{item.title || "-"}</div>

              <div className="care-summary-subtext dark-sub">
                {item.doctor || "-"}
              </div>

              <div className="care-summary-subtext">
                End Date : {item.date || "-"}
              </div>
            </div>

            <div className="treatment-count-badge">
              {item.completedGoals}/{item.totalGoals}
            </div>
          </div>
        ))}

        {plans.length === 0 && (
          <div className="care-summary-empty">No Treatment Plans Added</div>
        )}
      </div>
    </div>
  );
};

export default React.memo(TreatmentPlanCard);
